import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import './App.css';
import axios from 'axios';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import classNames from 'classnames';
import { Controller, useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader, showToast } from './store/reducers/interaction.slice';
import Toast from './components/Toast/Toast';
import Loader from './components/Loader/Loader';

function App({id}) {

  const dispatch = useDispatch();

  const [client, setClient] = useState(null);
  const [selectedDates, setSelectedDates] = useState(null);
  const [selectedBike, setSelectedBike] = useState(null);
  const [availableBikes, setAvailableBikes] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);

  const validationSchema = yup.object({
    lastName: yup
      .string()
      .max(100, 'max 100')
      .required('Le champ est requis'),
    firstName: yup
      .string()
      .max(100, 'max 100')
      .required('Le champ est requis'),
    email: yup
      .string()
      .email()
      .max(255, 'max 255')
      .required('Le champ est requis'),
    phone: yup
      .string()
      .max(50, 'max 50')
      .required('Le champ est requis'),
  });

  const defaultValues = {
    lastName: '',
    firstName: '',
    email: '',
    phone: '',
  };

  const { control, handleSubmit, reset, formState: { errors }, getValues } = useForm({defaultValues, resolver : yupResolver(validationSchema)});

  useEffect( () => {
    const title = document.querySelector('h1.text-center.mb-5');
    title.innerHTML = '';
    axios.defaults.baseURL = window.THEME_CONST.API_URI + 'api';
    axios.defaults.headers.common['X-WP-Nonce'] = window.THEME_CONST.NONCE;
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    loadData().then(data => {
      title.innerHTML = 'Réservations ' + data.name;
    });
  }, []);
  
  const loadData = () => {
    return axios.get('/client/' + id).then(result => {
      setClient(result.data);
      setAvailableDates(result.data.dates.filter(d => dayjs(d.startDate).isAfter(dayjs(new Date().toISOString()))));
      return result.data;
    });
  }
  
  useEffect(() => {
    if(!selectedDates)
      setSelectedDates(availableDates.find(_ => true));
  }, [availableDates]);

  useEffect(() => {
    setSelectedBike(null);
    if(client && selectedDates) {
      setAvailableBikes(client.bikes.map(bike => ({... bike, available: client.bookings.filter(b => b.datesId === selectedDates.id).every(b => b.bikeId !== bike.id)})));
    }
  }, [selectedDates, client]);

  const getFormData = (model) => {
    const fd = new FormData();
    for(const key of Object.keys(model)) {
        if(Array.isArray(model[key])) {
            fd.append(key, JSON.stringify(model[key]))
        }
        else {
            fd.append(key, model[key]);
        }
    }
    return fd;
  }

  const onSubmit = values => {
    if(!selectedBike) {
      dispatch(showToast({ severity: 'error', message: 'Veuillez choisir un vélo'}));
      return;
    }
    dispatch(showLoader());
    axios.post('/booking', getFormData({ ...values, bikeId: selectedBike.id, datesId: selectedDates.id, clientId: id  }))
      .then(result => {
        dispatch(showToast({ severity: 'success', message: 'Votre demande a bien été envoyée' }));
        setSelectedDates(null);
        reset(defaultValues);
        loadData();
      }).catch(xhr => {
        dispatch(showToast({ severity: 'error', message: xhr.response.data.message }));
      }).finally(() => {
        dispatch(hideLoader());
      });
  }

  return <>
  <div style={{ textAlign: 'center' }}>
      <img height={100} src='/wp-content/uploads/logo.png'/>
  </div>
      <p>Bienvenue sur la page web dédiée à la réservation de vélo pour le personnel des Cliniques universitaires Saint-Luc.<br />
Si vous souhaitez visiter le site web de Mojo avant de finaliser votre réservation, veillez à revenir sur cette page via le lien personnalisé pour Saint-Luc.</p>
    {(client && selectedDates) && <div>
      <h4>1. Choississez une période</h4>  
      <div className='row'>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel>Période</InputLabel>
          <Select label="Période" defaultValue={selectedDates?.id} onChange={({target}) => setSelectedDates(client.dates.find(c => c.id === target.value))}>
            { availableDates.map(d => 
              <MenuItem key={d.id} value={d.id}>Du {dayjs(d.startDate).format('DD/MM/YYYY')} au {dayjs(d.endDate).format('DD/MM/YYYY')}</MenuItem>
            ) }
          </Select>
        </FormControl>
      </div>
      {selectedDates && <>
        <h4>2. Sélectionnez votre vélo</h4>
      <div className='row stretch'>
        {availableBikes.map((b, i) => <div key={b.id} className="col-md-4 col-sm-6 mb-3">
          <h5>Vélo n° {i+1}</h5>  
          <div className={classNames('card', { selected: b === selectedBike, notAvailable: !b.available })}>
            <img className="card-img-top" src={b.image} />
            <hr />
            <div className="card-body">
                <h5 className="card-title">{b.title}</h5>
                <p dangerouslySetInnerHTML={{__html: b.description?.replace('\n', '<br/>')}}></p>
            </div>
            <div className='card-footer text-center'>
              {
                b.available ? 
                <button disabled={!b.available} className='btn btn-warning' variant='contained' onClick={() => setSelectedBike(b)}>{b.available ? 'Sélectionner' : 'Déjà réservé'}</button> : 
                <p className='text-danger'>Déjà réservé</p>
              }
            </div>
          </div>
        </div>)}
      </div></>}
      {<div>
        <h4>3. Complétez le formulaire</h4>
        <form className='row' onSubmit={handleSubmit(onSubmit)}>
          <div className='col-md-6 col-sm-12 mb-3'>
          <Controller 
              name="lastName"
              control={control} 
              render={({ field }) => 
                <TextField {...field}
                  label="Nom"
                  fullWidth={true}
                  required={true}
                  error={!!errors.lastName}
                  helperText={!!errors.lastName && errors.lastName.message} />
              } />
          </div>
          <div className='col-md-6 col-sm-12 mb-3'>
          <Controller 
              name="firstName"
              control={control} 
              render={({ field }) => 
                <TextField {...field}
                  label="Prénom"
                  fullWidth={true}
                  required={true}
                  error={!!errors.firstName}
                  helperText={!!errors.firstName && errors.firstName.message} />
              } />
          </div>
          <div className='col-md-6 col-sm-12 mb-3'>
          <Controller 
              name="email"
              control={control} 
              render={({ field }) => 
                <TextField {...field}
                  label="Votre adresse email professionnelle"
                  fullWidth={true}
                  required={true}
                  error={!!errors.email}
                  helperText={!!errors.email && errors.email.message} />
              } />
          </div>
          <div className='col-md-6 col-sm-12 mb-3'>
          <Controller 
              name="phone"
              control={control} 
              render={({ field }) => 
                <TextField {...field}
                  label="Tel"
                  fullWidth={true}
                  required={true}
                  error={!!errors.phone}
                  helperText={!!errors.phone && errors.phone.message} />
              } />
          </div>
          <div className='col-sm-12 mb-3 text-right'>
            <button type="submit" className='btn btn-warning'>Envoyer <i className='fa fa-paper-plane'></i></button>
          </div>
        </form>
      </div>}
    </div>}
    <Toast></Toast>
    <Loader></Loader>
  </>;
}

export default App;
